import { ensureIdaOkOrShowModal } from "./systems-status";

window.choicesArray = [];
jQuery(function ($) {
  $(document).ready(function () {
    // START Anmalan form
    dublicateDietRow();

    // jQuery.validator.addMethod("telefonnummer", function(value, element) {
    //     return this.optional(element) || /^([0|+[0-9()]{1,9})?([\w.\-])?([1-9][0-9]{3,9})$/.test(value);
    // }, "Vänligen ange rätt telefonnummer");

    jQuery.validator.addMethod(
      "emailcheck",
      function (value, element) {
        return (
          this.optional(element) ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
        );
      },
      "Vänligen ange rätt e-postadress"
    );

    $("#select-funeral").change(function () {
      var optionValue = $(this).val();
      var optionId = $("#" + optionValue);
      var optionIdValue = $("#" + optionValue).val();
      var dataPlace = optionId.data("reception_place");
      var dataPlaceCeremony = optionId.data("ceremony_place");
      var dataDate = optionId.data("reception_date");
      var dataTime = optionId.data("reception_time");
      var dataDateCeremony = optionId.data("ceremony_date");
      var dataTimeCeremony = optionId.data("ceremony_time");
      var dataDeceasedName = optionId.data("deceased_name");
      var dataDateRsvp = optionId.data("rsvp_date");
      var dataValidRsvp = optionId.data("rsvp_valid");

      $("#ceremoniloc").val(dataPlaceCeremony);
      $("#ceremonidate").val(dataDateCeremony);
      $("#ceremonitime").val(dataTimeCeremony);
      $("#addinfoloc").val(dataPlace);
      $("#rsvpinfodate").val(dataDateRsvp);
      $("#addinfodate").val(dataDate);
      $("#addinfotime").val(dataTime);
      $("#addinfoname").val(dataDeceasedName);
      // return dataDeceasedName;
      $("#addinfoname-error").hide();
      if (dataValidRsvp == false) {
        $("#funeralFormSubmit").prop("disabled", true);
        $("#jag").prop("disabled", true);
        $("#namn").prop("disabled", true);
        $("#fornamn").prop("disabled", true);
        $("#telefonnummer").prop("disabled", true);
        $("#email").prop("disabled", true);
        $("#angeantal").prop("disabled", true);
        // $('div.diet-rows-container').hide();
        $("div.diet-rows-container").css("filter", "saturate(0)");
        $("button.choices__button").prop("disabled", true);
        $("div.diet-rows-container").css("opacity", "0.4");
        $(".food-restrictions-ppl").prop("disabled", true);
        $(".remove-diet-row").hide();
        window.choicesArray.forEach(function (oneChoiceRow, index) {
          oneChoiceRow.disable();
        });
      } else {
        $("#funeralFormSubmit").prop("disabled", false);
        $("#jag").prop("disabled", false);
        $("#namn").prop("disabled", false);
        $("#fornamn").prop("disabled", false);
        $("#telefonnummer").prop("disabled", false);
        $("#email").prop("disabled", false);
        $("#angeantal").prop("disabled", false);
        // $('div.diet-rows-container').show();
        $("div.diet-rows-container").css("filter", "none");
        $("div.diet-rows-container").css("opacity", "1");
        $("button.choices__button").prop("disabled", false);
        $(".food-restrictions-ppl").prop("disabled", false);
        $(".remove-diet-row").show();
        window.choicesArray.forEach(function (oneChoiceRow, index) {
          oneChoiceRow.enable();
        });
      }
    });
    $("#funeralFormSubmit").click(async function (e) {
      e.preventDefault();
      var $this = $(this);

      if (!$("#select-funeral").val()) {
        $("#addinfoname-error").show();
        scrollToFormTop($(".memory-notification-wrapper"));
      } else {
        var validRsvp = $("#rsvpForm").valid();
        if (validRsvp) {
          if (!(await ensureIdaOkOrShowModal())) {
            return;
          }
          $this.prop("disabled", true);
          $.post("", $("#rsvpForm").serialize())
            .done(function (data) {
              $(".form-error").remove();
              if (data.status === "success") {
                $("#rsvp-thanks").show();
                $("#rsvpForm").hide();
                //$("#rsvp-image").hide();
                $(".container-landing > div.container").hide();
                $("html, body").animate(
                  { scrollTop: $("#main").offset().top },
                  "slow"
                );
              } else if (data.status === "error") {
                $this
                  .closest(".justify-content-end")
                  .append(
                    `<div class="col-12 form-error"><div class="alert alert-danger">${data.message}</div></div>`
                  );
              }
            })
            .always(function () {
              $this.prop("disabled", false);
            });
        }
      }
    });
    $("#rsvpForm").validate({
      rules: {
        funeral: "required",
        namn: {
          required: true,
          lettersonly: true,
        },
        fornamn: {
          required: true,
          lettersonly: true,
        },
        email: {
          required: false,
          emailcheck: true,
        },
        telefonnummer: {
          required: true,
          fenixSEPhone: true,
        },
        angeantal: {
          required: false,
          digits: true,
          min: 0,
        },
        allergier: "required",
        jag: "required",
      },
      focusCleanup: true,
      onfocusout: false,
      onkeyup: false,
      onclick: false,
    });
    $("#rsvpReset").click(function () {
      $("#rsvpForm")[0].reset();

      $("#diet-rows-wrapper > div").each(function (index, val) {
        $(val).remove();
      });
      dublicateDietRow();
    });
    $("#diet-rows-wrapper").on("click", ".remove-diet-row", function (e) {
      e.preventDefault();
      var rows = $("#diet-rows-wrapper > div").length;
      var currentRow = $(this).closest(".row");

      if (rows > 1) {
        currentRow.remove();
      }

      reassignInputIndexes();
    });
    function dublicateDietRow() {
      var rows = $("#diet-rows-wrapper > div").length;

      var el = $(".diet-template")
        .clone(true)
        .removeClass("diet-template")
        .css("display", "flex")
        .appendTo("#diet-rows-wrapper");
      el.find(".food-restrictions-name").attr(
        "name",
        `food-restrictions[${rows}][name]`
      );
      el.find(".food-restrictions-value").attr(
        "name",
        `food-restrictions[${rows}][value]`
      );
      el.find(".food-restrictions-ppl").attr(
        "name",
        `food-restrictions[${rows}][ppl]`
      );

      try {
        Choices.prototype._onEnterKey = function (
          event,
          activeItems,
          hasActiveDropdown
        ) {
          event.preventDefault();
          return false;
        };
        var selectEl = el.find(".food-restrictions")[0];
        var select = new Choices(selectEl, {
          removeItems: true,
          silent: true,
          removeItemButton: true,
          placeholder: true,
          searchPlaceholderValue: $(selectEl).attr("placeholder"),
          itemSelectText: "",
          noResultsText: "Tryck på Enter för att lägga till ett valfritt",
        });
        window.choicesArray.push(select);
        const choicesIssue39Fix = (choicesElement) => {
          choicesElement.input.element.addEventListener(
            "keydown",
            (keypressEvent) => {
              if (keypressEvent.keyCode === 13 && keypressEvent.target.value) {
                keypressEvent.stopPropagation();
                choicesElement.setChoices(
                  [
                    {
                      value: keypressEvent.target.value,
                      label: keypressEvent.target.value,
                      selected: true,
                    },
                  ],
                  "value",
                  "label",
                  false
                );
                const linterEvent = keypressEvent;
                linterEvent.target.value = "";

                var values = select.getValue();
                $(selectEl)
                  .closest(".choices")
                  .next("input.food-restrictions-value")
                  .attr(
                    "value",
                    values ? values.map((el) => el.value).join(",") : ""
                  )
                  .next("input.food-restrictions-name")
                  .attr(
                    "value",
                    values ? values.map((el) => el.label).join(",") : ""
                  );

                var rows = $("#diet-rows-wrapper > div").length;
                if ((!$(selectEl).data("created") || rows === 1) && values) {
                  dublicateDietRow();
                }
                $(selectEl).data("created", 1);

                if (values.length !== 0) {
                  $(selectEl).siblings("input").attr("placeholder", "");
                }
              }
            }
          );
        };
        choicesIssue39Fix(select);
        selectEl.addEventListener(
          "change",
          function (e) {
            var values = select.getValue();

            var rows = $("#diet-rows-wrapper > div").length;
            $(this)
              .closest(".choices")
              .next("input.food-restrictions-value")
              .attr(
                "value",
                values ? values.map((el) => el.value).join(",") : ""
              )
              .next("input.food-restrictions-name")
              .attr(
                "value",
                values ? values.map((el) => el.label).join(",") : ""
              );
            if ((!$(this).data("created") || rows === 1) && values) {
              dublicateDietRow();
            }
            $(this).data("created", 1);

            var pplEl = el.find(".food-restrictions-ppl");
            if (!pplEl.val()) {
              pplEl.attr("value", 1);
            }

            if (values.length === 0) {
              pplEl.attr("value", "");
              $(this)
                .siblings("input")
                .attr("placeholder", $(this).data("placeholder"))
                .css("width", "auto");
            } else {
              $(this).siblings("input").attr("placeholder", "");
            }
          },
          false
        );
      } catch (e) {}
    }
    function scrollToFormTop(el, offset) {
      if (offset === undefined) {
        offset = 0;
      }
      if ($(window).width() > 575) {
        offset = -110;
      }

      var objToScroll = el;
      setTimeout(function () {
        $("html, body")
          .delay(10)
          .animate({ scrollTop: objToScroll.offset().top + offset }, 400);
      }, 300);
    }
    function reassignInputIndexes() {
      $("#diet-rows-wrapper .food-restrictions-name").each(function (ind, el) {
        $(this).attr("name", `food-restrictions[${ind}][name]`);
      });
      $("#diet-rows-wrapper .food-restrictions-value").each(function (ind, el) {
        $(this).attr("name", `food-restrictions[${ind}][value]`);
      });
      $("#diet-rows-wrapper .food-restrictions-ppl").each(function (ind, el) {
        $(this).attr("name", `food-restrictions[${ind}][ppl]`);
      });
    }
    // END ANMALAN form
  });
});
